import React, { ReactNode } from "react";

import { useTranslation } from "utils";

import { CMC_MIX_TYPE } from "models";

import { Flex, Tag, Typography } from "components";

import { CMC_ROUTES } from "pages/app/crop-mix-composer/CropMixComposerOverlay";
import { useActiveCropMixSettings } from "pages/app/crop-mix-composer/utils/useActiveCropMixSettings";

export const MixSectionHeader = ({ title, subTitle, actions }: { title: string; subTitle: string; actions?: ReactNode }) => {
  const { t } = useTranslation("cropMixComposer");
  const activeCropMixSettings = useActiveCropMixSettings();

  const isSmartMix = activeCropMixSettings?.mixType === CMC_MIX_TYPE.AUTO_GENERATED;

  return (
    <Flex className="mix-details-section-header" align="flex-start" justify="space-between">
      <Flex className="header-text" align="center" gap="0.5rem">
        <Flex className="header-title-container" align="center" gap="0.5rem">
          <Typography variant="paragraph-m" bold className="header-title margin-0">
            {title}
          </Typography>
          {isSmartMix && <Tag className="margin-0" colour="yellow" text={t(`page.${CMC_ROUTES.OVERVIEW}.smartMix`)} />}
        </Flex>
        <Typography variant="paragraph-m" className="header-curated-mix margin-0">
          {subTitle}
        </Typography>
      </Flex>
      {actions ? (
        <Flex className="header-actions" align="center" gap="0.5rem">
          {actions}
        </Flex>
      ) : null}
    </Flex>
  );
};
